/* tslint:disable:max-line-length */
export const REDIRECT_BE = {
'/bonen' :  '/nl/producten',
'/fr/astuce/aubergine-grillee-aux-champignons' :  '/fr',
'/fr/astuce/aubergine-grillee-aux-champignons/champignon-de-paris' :  '/fr',
'/fr/astuce/aubergine-grillee-aux-champignons/pleurote' :  '/fr',
'/fr/astuce/boeuf-la-sauce-champignons' :  '/fr',
'/fr/astuce/boeuf-la-sauce-champignons/champignon-de-paris' :  '/fr',
'/fr/astuce/boeuf-la-sauce-champignons/chanterelle' :  '/fr',
'/fr/astuce/bouchee-de-pate-feuilletee-aux-champignons' :  '/fr',
'/fr/astuce/bouchee-de-pate-feuilletee-aux-champignons/champignon-de-paris' :  '/fr',
'/fr/astuce/burgers-borlotti' :  '/fr',
'/fr/astuce/burgers-borlotti/haricots-borlotti' :  '/fr',
'/fr/astuce/carottes-aux-amandes-et-au-curry' :  '/fr',
'/fr/astuce/carottes-aux-amandes-et-au-curry/carotte' :  '/fr',
'/fr/astuce/carottes-aux-pommes-fraicheur' :  '/fr',
'/fr/astuce/carottes-aux-pommes-fraicheur/carotte' :  '/fr',
'/fr/astuce/carre-aux-champignons' :  '/fr',
'/fr/astuce/carre-aux-champignons/champignon-de-paris' :  '/fr',
'/fr/astuce/carre-aux-champignons/chanterelle' :  '/fr',
'/fr/astuce/champignons-avec-croute-damandes' :  '/fr',
'/fr/astuce/champignons-avec-croute-damandes/champignon-de-paris' :  '/fr',
'/fr/astuce/champignons-avec-croute-damandes/chanterelle' :  '/fr',
'/fr/astuce/champignons-gratines' :  '/fr',
'/fr/astuce/champignons-gratines/champignon-de-paris' :  '/fr',
'/fr/astuce/champignons-la-chinoise' :  '/fr',
'/fr/astuce/champignons-la-chinoise/champignon-de-paris' :  '/fr',
'/fr/astuce/champignons-la-chinoise/pleurote' :  '/fr',
'/fr/astuce/chips-tortilla-et-haricots-chili' :  '/fr',
'/fr/astuce/chou-rouge-aux-pommes-fraiches' :  '/fr',
'/fr/astuce/chou-rouge-aux-pommes-fraiches/chou-rouge' :  '/fr',
'/fr/astuce/chou-rouge-hivernal' :  '/fr',
'/fr/astuce/chou-rouge-hivernal/chou-rouge' :  '/fr',
'/fr/astuce/couscous-epice' :  '/fr',
'/fr/astuce/couscous-epice/flageolet-vert' :  '/fr',
'/fr/astuce/crepes-de-mais' :  '/fr',
'/fr/astuce/crevettes-aux-haricots-cannellini' :  '/fr',
'/fr/astuce/crevettes-aux-haricots-cannellini/haricots-cannellini' :  '/fr',
'/fr/astuce/epinard-aux-pignons-de-pin' :  '/fr',
'/fr/astuce/epinard-aux-pignons-de-pin/les-epinards' :  '/fr',
'/fr/astuce/epinard-aux-tomates-sechees-au-soleil' :  '/fr',
'/fr/astuce/epinard-aux-tomates-sechees-au-soleil/les-epinards' :  '/fr',
'/fr/astuce/epinard-la-creme' :  '/fr',
'/fr/astuce/epinard-la-creme/les-epinards' :  '/fr',
'/fr/astuce/etuvee-au-poulet' :  '/fr',
'/fr/astuce/etuvee-au-poulet/flageolet-vert' :  '/fr',
'/fr/astuce/etuvee-de-haricots-blancs' :  '/fr',
'/fr/astuce/etuvee-de-haricots-blancs/haricot-blanc' :  '/fr',
'/fr/astuce/feves-au-pesto' :  '/fr',
'/fr/astuce/feves-au-pesto/feve' :  '/fr',
'/fr/astuce/feves-la-lyonnaise' :  '/fr',
'/fr/astuce/feves-la-lyonnaise/feve' :  '/fr',
'/fr/astuce/feves-la-sauce-de-yaourt-fraiche' :  '/fr',
'/fr/astuce/feves-la-sauce-de-yaourt-fraiche/feve' :  '/fr',
'/fr/astuce/frittata-italienne-de-mais' :  '/fr',
'/fr/astuce/frittata-italienne-de-mais/mais' :  '/fr',
'/fr/astuce/haricots-beurre-aux-amandes' :  '/fr',
'/fr/astuce/haricots-beurre-aux-amandes/haricot-beurre' :  '/fr',
'/fr/astuce/haricots-beurre-caramelises' :  '/fr',
'/fr/astuce/haricots-beurre-caramelises/haricot-beurre' :  '/fr',
'/fr/astuce/haricots-beurre-la-chinoise' :  '/fr',
'/fr/astuce/haricots-beurre-la-chinoise/haricot-beurre' :  '/fr',
'/fr/astuce/haricots-blancs-au-curry-madras' :  '/fr',
'/fr/astuce/haricots-blancs-au-curry-madras/haricot-blanc' :  '/fr',
'/fr/astuce/haricots-blancs-dhiver' :  '/fr',
'/fr/astuce/haricots-blancs-dhiver/haricot-blanc' :  '/fr',
'/fr/astuce/haricots-chili-la-sauce-epicee' :  '/fr',
'/fr/astuce/haricots-geants-la-sauce-tomate' :  '/fr',
'/fr/astuce/haricots-geants-la-sauce-tomate/haricots-geants' :  '/fr',
'/fr/astuce/haricots-geants-lafricaine' :  '/fr',
'/fr/astuce/haricots-geants-lafricaine/haricots-geants' :  '/fr',
'/fr/astuce/haricots-la-provencale' :  '/fr',
'/fr/astuce/haricots-la-provencale/haricots-cannellini' :  '/fr',
'/fr/astuce/haricots-rouges-et-champignons-en-plat-au-four' :  '/fr',
'/fr/astuce/haricots-rouges-et-champignons-en-plat-au-four/haricot-rouge' :  '/fr',
'/fr/astuce/haricots-verts-aux-champignons' :  '/fr',
'/fr/astuce/haricots-verts-aux-champignons/haricot-vert' :  '/fr',
'/fr/astuce/haricots-verts-indonesie' :  '/fr',
'/fr/astuce/haricots-verts-indonesie/haricot-vert' :  '/fr',
'/fr/astuce/haricots-verts-la-francaise' :  '/fr',
'/fr/astuce/haricots-verts-la-francaise/haricot-vert' :  '/fr',
'/fr/astuce/haricots-verts-la-hollandaise' :  '/fr',
'/fr/astuce/haricots-verts-la-hollandaise/haricot-vert' :  '/fr',
'/fr/astuce/haricots-verts-la-mediterraneenne' :  '/fr',
'/fr/astuce/haricots-verts-la-mediterraneenne/haricot-vert' :  '/fr',
'/fr/astuce/haricots-verts-la-mexicaine' :  '/fr',
'/fr/astuce/haricots-verts-la-mexicaine/haricot-vert' :  '/fr',
'/fr/astuce/jeunes-carottes-laneth' :  '/fr',
'/fr/astuce/jeunes-carottes-laneth/carotte' :  '/fr',
'/fr/astuce/legumes-grilles-avec-pois-chiches' :  '/fr',
'/fr/astuce/legumes-grilles-avec-pois-chiches/pois-chiche' :  '/fr',
'/fr/astuce/lentilles-aux-champignons' :  '/fr',
'/fr/astuce/lentilles-aux-champignons/lentilles' :  '/fr',
'/fr/astuce/lentilles-la-marocaine' :  '/fr',
'/fr/astuce/lentilles-la-marocaine/lentilles' :  '/fr',
'/fr/astuce/lentilles-lail-la-sauce-au-porto' :  '/fr',
'/fr/astuce/lentilles-lail-la-sauce-au-porto/lentilles' :  '/fr',
'/fr/astuce/macedoine-aux-champignons' :  '/fr',
'/fr/astuce/macedoine-aux-champignons/carotte' :  '/fr',
'/fr/astuce/macedoine-aux-champignons/haricot-vert' :  '/fr',
'/fr/astuce/macedoine-aux-champignons/petit-pois' :  '/fr',
'/fr/astuce/pates-au-mais-et-poulet' :  '/fr',
'/fr/astuce/pates-cannellini' :  '/fr',
'/fr/astuce/pates-cannellini/haricots-cannellini' :  '/fr',
'/fr/astuce/petits-pois-au-fenouil' :  '/fr',
'/fr/astuce/petits-pois-au-fenouil/petit-pois' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-epices' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-epices/carotte' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-epices/petit-pois' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-la-grecque' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-la-grecque/carotte' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-la-grecque/petit-pois' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-letuvee-la-creme-fraiche' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-letuvee-la-creme-fraiche/carotte' :  '/fr',
'/fr/astuce/petits-pois-et-carottes-letuvee-la-creme-fraiche/petit-pois' :  '/fr',
'/fr/astuce/petits-pois-la-marocaine' :  '/fr',
'/fr/astuce/petits-pois-la-marocaine/petit-pois' :  '/fr',
'/fr/astuce/petits-pois-lorange' :  '/fr',
'/fr/astuce/petits-pois-lorange/petit-pois' :  '/fr',
'/fr/astuce/pois-chiches-facon-egyptienne' :  '/fr',
'/fr/astuce/pois-chiches-facon-egyptienne/pois-chiche' :  '/fr',
'/fr/astuce/potee-de-chou-rouge-au-vin-rouge' :  '/fr',
'/fr/astuce/potee-de-chou-rouge-au-vin-rouge/chou-rouge' :  '/fr',
'/fr/astuce/puree-de-legumes-aux-haricots-geants' :  '/fr',
'/fr/astuce/puree-de-legumes-aux-haricots-geants/haricots-geants' :  '/fr',
'/fr/astuce/risotto-aux-haricots-borlotti' :  '/fr',
'/fr/astuce/risotto-aux-haricots-borlotti/haricots-borlotti' :  '/fr',
'/fr/astuce/salade-de-couscous-fraiche' :  '/fr',
'/fr/astuce/salade-de-couscous-fraiche/flageolet-vert' :  '/fr',
'/fr/astuce/salade-de-crabe-au-mais' :  '/fr',
'/fr/astuce/salade-de-macedoine' :  '/fr',
'/fr/astuce/salade-de-macedoine/carotte' :  '/fr',
'/fr/astuce/salade-de-macedoine/haricot-vert' :  '/fr',
'/fr/astuce/salade-de-macedoine/petit-pois' :  '/fr',
'/fr/astuce/salade-de-pois-chiches-fraiche' :  '/fr',
'/fr/astuce/salade-de-pois-chiches-fraiche/pois-chiche' :  '/fr',
'/fr/astuce/salade-tomates-et-fromage-bleu' :  '/fr',
'/fr/astuce/salade-tomates-et-fromage-bleu/haricots-borlotti' :  '/fr',
'/fr/astuce/salsa-au-mais' :  '/fr',
'/fr/astuce/salsa-au-mais/mais' :  '/fr',
'/fr/astuce/saucisses-farcies' :  '/fr',
'/fr/astuce/saucisses-farcies/carotte' :  '/fr',
'/fr/astuce/saucisses-farcies/haricot-vert' :  '/fr',
'/fr/astuce/saucisses-farcies/petit-pois' :  '/fr',
'/fr/astuce/tacos-mexicains' :  '/fr',
'/fr/astuce/tacos-mexicains/haricot-rouge' :  '/fr',
'/fr/astuce/tapa-de-mais-au-chorizo' :  '/fr',
'/fr/astuce/tapa-de-mais-au-chorizo/mais' :  '/fr',
'/fr/astuce/toast-aux-champignons' :  '/fr',
'/fr/astuce/toast-aux-champignons/champignon-de-paris' :  '/fr',
'/fr/astuce/toast-aux-champignons/pleurote' :  '/fr',
'/fr/astuce/tortilla-au-poulet-et-salsa' :  '/fr',
'/fr/astuce/tortilla-au-poulet-et-salsa/haricot-rouge' :  '/fr',
'/fr/astuce/veloute-de-champignons-avec-chapeau' :  '/fr',
'/fr/astuce/veloute-de-champignons-avec-chapeau/champignon-de-paris' :  '/fr',
'/fr/blogger' :  '/fr',
'/fr/contactez-nous': '/fr/nous-contacter',
'/fr/disclaimer' :  '/fr/politique-confidentialite',
'/fr/jet-kookt-met' :  '/fr',
'/fr/legume/aubergine' :  '/fr/legumes/p/aubergines-a-la-provencale/03083681009743',
'/fr/legume/carotte' :  '/fr/legumes/p/carottes-extra-fines/03083680613866',
'/fr/legume/champignon-de-paris' :  '/fr/legumes/p/champignons-de-paris-et-pleurotes/03083681005851',
'/fr/legume/chanterelle' :  '/fr',
'/fr/legume/chou-rouge' :  '/fr',
'/fr/legume/courgette' :  '/fr',
'/fr/legume/feve' :  '/fr/legumes/p/feves/03083681012521',
'/fr/legume/flageolet-vert' :  '/fr/legumes/p/flageolets/03083680613354',
'/fr/legume/haricot-beurre' :  '/fr/legumes/legume/haricot-beurre',
'/fr/legume/haricot-blanc' :  '/fr/legumes/p/haricots-blancs/03083681023268',
'/fr/legume/haricot-noir' :  '/fr/legumes/p/haricots-noirs/03083681007800',
'/fr/legume/haricot-rouge' :  '/fr/recette/legume/haricot-rouge',
'/fr/legume/haricot-vert' :  '/fr/legumes/p/haricots-verts-extra-fins-ranges/03083680597135',
'/fr/legume/haricots-borlotti' :  '/fr/legumes/p/haricots-borlotti/03083681003925',
'/fr/legume/haricots-cannellini' :  '/fr/legumes/p/haricots-cannellini/03083681003901',
'/fr/legume/haricots-geants' :  '/fr/legumes/p/haricots-geants/03083681012620',
'/fr/legume/lentilles' :  '/fr/recette/legume/lentilles',
'/fr/legume/les-epinards' :  '/fr/legumes/p/epinards-haches/03083680001243',
'/fr/legume/mais' :  '/fr/recette/legume/mais',
'/fr/legume/petit-pois' :  '/fr/legumes/p/petits-pois-extra-fins/03083681012705',
'/fr/legume/pleurote' :  '/fr/legumes/p/champignons-de-paris-et-pleurotes/03083681005851',
'/fr/legume/pois-chiche' :  '/fr/recette/legume/pois-chiche',
'/fr/legumes' :  '/fr/legumes',
'/fr/legumes-avec-plus-de-gout' :  '/fr',
'/fr/legumes/pates-riz-legumineuses': '/fr/legumes/pates-riz-legumes',
'/fr/legumes?page=1' :  '/fr',
'/fr/node/20' :  '/fr',
'/fr/node/27' :  '/fr',
'/fr/node/41' :  '/fr',
'/fr/node/57' :  '/fr',
'/fr/privacy-policy' :  '/fr',
'/fr/produit/aubergines-la-provencale' :  '/fr/legumes/p/aubergines-a-la-provencale/03083681009743',
'/fr/produit/carottes-en-rondelles' :  '/fr/legumes/p/carottes-rondelles/03083681005332',
'/fr/produit/carottes-extra-fins' :  '/fr/legumes/p/carottes-extra-fines/03083680613866',
'/fr/produit/cerfeuil' :  '/fr/legumes/legume/cerfeuil',
'/fr/produit/champignons-de-paris-eminces' :  '/fr',
'/fr/produit/champignons-de-paris-girolles' :  '/fr',
'/fr/produit/champignons-de-paris-mini' :  '/fr/legumes/p/champignons-de-paris-mini/03083681005783',
'/fr/produit/champignons-de-paris-pleurotes' :  '/fr/legumes/p/champignons-de-paris-et-pleurotes/03083681005851',
'/fr/produit/choux-rouges-aux-pommes' :  '/fr',
'/fr/produit/coeurs-de-celeri' :  '/fr/legumes/p/coeurs-de-celeri/03083680600873',
'/fr/produit/courgettes-la-provencale' :  '/fr',
'/fr/produit/crispy-mais' :  '/fr/legumes/p/crispy-mais-bio/03083681002393',
'/fr/produit/crispy-mais-bio' :  '/fr/legumes/p/crispy-mais-2-mini-packs/03083681068184',
'/fr/produit/crispy-mais-mini-packs' :  '/fr/legumes/p/crispy-mais/03083680597210',
'/fr/produit/epinards-haches' :  '/fr/legumes/p/epinards-haches/03083680613910',
'/fr/produit/fantasia-mais-fiesta' :  '/fr',
'/fr/produit/feves-extra-fines' :  '/fr/legumes/legume/feves',
'/fr/produit/flageolets' :  '/fr/legumes/p/flageolets/03083680613354',
'/fr/produit/haricots-beurre-tres-fins' :  '/fr/legumes/p/haricots-beurre-tres-fins/03083680600835',
'/fr/produit/haricots-blancs' :  '/fr/legumes/p/haricots-blancs-en-sauce-tomate/03083680010726',
'/fr/produit/haricots-blancs-en-sauce-tomate' :  '/fr/legumes/p/haricots-blancs/03083681023268',
'/fr/produit/haricots-borlotti' :  '/fr/legumes/p/haricots-borlotti/03083681003925',
'/fr/produit/haricots-cannellini' :  '/fr/legumes/p/haricots-cannellini/03083681003901',
'/fr/produit/haricots-geants' :  '/fr/legumes/p/haricots-geants/03083681012620',
'/fr/produit/haricots-noirs' :  '/fr/legumes/p/haricots-noirs/03083681007800',
'/fr/produit/haricots-oeil-noir' :  '/fr',
'/fr/produit/haricots-rouges-kidney' :  '/fr/legumes/p/haricots-rouges-kidney-2-mini-packs/03083681068122',
'/fr/produit/haricots-rouges-kidney-mini-packs' :  '/fr/legumes/p/haricots-rouges-kidney/03083681012606',
'/fr/produit/haricots-verts-brises' :  '/fr/legumes/p/haricots-verts-brises/03083680613767',
'/fr/produit/haricots-verts-extra-fins-ranges' :  '/fr/legumes/p/haricots-verts-extra-fins-ranges/03083680597135',
'/fr/produit/haricots-verts-extra-fins-ranges-0' :  '/fr/legumes/p/haricots-verts-extra-fins-ranges/03083680597128',
'/fr/produit/haricots-verts-miniature' :  '/fr',
'/fr/produit/haricots-verts-tres-fins' :  '/fr/legumes/p/haricots-verts-tres-fins-ranges/03083680534796',
'/fr/produit/haricots-verts-tres-fins-ranges' :  '/fr/legumes/p/haricots-verts-tres-fins-ranges/03083680534796',
'/fr/produit/lentilles' :  '/fr/recette/legume/lentilles',
'/fr/produit/macedoine-de-legumes' :  '/fr/legumes/p/macedoine-de-legumes/03083680600910',
'/fr/produit/macedoine-de-legumes-0' :  '/fr/legumes/p/macedoine-de-legumes/03083680002981',
'/fr/produit/mais-mexicana' :  '/fr/legumes/p/mais-mexicana/03083680597159',
'/fr/produit/mais-pour-salade' :  '/fr/legumes/p/mais-pour-salade/03083681034646',
'/fr/produit/mais-salsa' :  '/fr',
'/fr/produit/oseille' :  '/fr/legumes/p/oseille/03083680594172',
'/fr/produit/petits-pois-carottes-extra-fins' :  '/fr/legumes/p/petits-pois-et-carottes-extra-fins/03083681028485',
'/fr/produit/petits-pois-carottes-extra-fins-0' :  '/fr/legumes/p/petits-pois-et-carottes-extra-fins/03083681028485',
'/fr/produit/petits-pois-carottes-tres-fins' :  '/fr/legumes/p/petits-pois-et-carottes-tres-fins/03083681012804',
'/fr/produit/petits-pois-extra-fins' :  '/fr/legumes/p/petits-pois-extra-fins/03083681012705',
'/fr/produit/petits-pois-extra-fins-0' :  '/fr/legumes/p/petits-pois-extra-fins/03083681012729',
'/fr/produit/petits-pois-festini' :  '/fr/legumes/p/pois-festini/03083680597142',
'/fr/produit/petits-pois-tres-fins' :  '/fr',
'/fr/produit/poeler-la-champetre' :  '/fr',
'/fr/produit/poeler-la-parisienne' :  '/fr',
'/fr/produit/pois-chiches' :  '/fr/legumes/p/pois-chiches-2-mini-packs/03083681068146',
'/fr/produit/pois-chiches-mini-packs' :  '/fr/legumes/p/pois-chiches/03083681006964',
'/fr/produit/pommes-de-terre' :  '/fr/legumes/legume/pommes-de-terre',
'/fr/produit/pruneaux-au-sirop' :  '/fr/legumes/p/pruneaux-au-sirop/03083680020411',
'/fr/produit/ratatouille-la-provencale' :  '/fr/legumes/p/ratatouille-a-la-provencale/03083681009767',
'/fr/produits' :  '/fr/legumes',
'/fr/produits/cherchez/mots-cles/logo%2Bviolet' :  '/fr/legumes',
'/fr/produits?page=1' :  '/fr/legumes',
'/fr/produits?page=2' :  '/fr/legumes?p=2',
'/fr/produits?page=3' :  '/fr/legumes?p=3',
'/fr/produits?page=4' :  '/fr/legumes?p=4',
'/fr/propos-de-bonduelle' :  '/fr/a-propos/actualites',
'/fr/propos-de-bonduelle/annonces' :  '/fr/a-propos/notre-histoire',
'/fr/propos-de-bonduelle/lhistoire' :  '/fr/a-propos/actualites',
'/fr/propos-de-bonduelle/processus' :  '/fr/a-propos/actualites',
'/fr/recepten/zoeken' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/gevogelte' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/pasta' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/rijst' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/vegetarisch' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/vis' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/gerecht/vlees' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/keuken/aziatisch' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/keuken/mediterraan' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/keuken/midden-oosten' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/keuken/westers' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/keuken/zuid-amerikaans' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/bijgerecht' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/hoofdgerecht' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/lunch' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/lunch?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/lunch?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/lunch?page=3' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/lunch?page=4' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/nagerecht' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/soep' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/tussendoortje' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/menugang/voorgerecht' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/eenhappers' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/feestje' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/snack-time' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/snack-time?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/snack-time?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/spicy' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/spicy?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/spicy?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/super-salads' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/super-salads?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/super-salads?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/super-salads?page=3' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/viva-la-vega' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/viva-la-vega?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/viva-la-vega?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/viva-la-vega?page=3' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/viva-la-vega?page=4' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood/werelds' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=10' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=11' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=12' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=13' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=14' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=15' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=3' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=4' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=5' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=6' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=7' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=8' :  '/fr/recettes',
'/fr/recepten/zoeken/categorie/mood?page=9' :  '/fr/recettes',
'/fr/recepten/zoeken?page=1' :  '/fr/recettes',
'/fr/recepten/zoeken?page=10' :  '/fr/recettes',
'/fr/recepten/zoeken?page=11' :  '/fr/recettes',
'/fr/recepten/zoeken?page=12' :  '/fr/recettes',
'/fr/recepten/zoeken?page=13' :  '/fr/recettes',
'/fr/recepten/zoeken?page=14' :  '/fr/recettes',
'/fr/recepten/zoeken?page=15' :  '/fr/recettes',
'/fr/recepten/zoeken?page=2' :  '/fr/recettes',
'/fr/recepten/zoeken?page=3' :  '/fr/recettes',
'/fr/recepten/zoeken?page=4' :  '/fr/recettes',
'/fr/recepten/zoeken?page=5' :  '/fr/recettes',
'/fr/recepten/zoeken?page=6' :  '/fr/recettes',
'/fr/recepten/zoeken?page=7' :  '/fr/recettes',
'/fr/recepten/zoeken?page=8' :  '/fr/recettes',
'/fr/recepten/zoeken?page=9' :  '/fr/recettes',
'/fr/recette/asperges-grillees-au-mais-haricots-noirs-et-croutons': '/fr/recette/r/asperges-grillees-au-mais-haricots-noirs-et-croutons/begp025',
'/fr/recette/aubergine-farcie-et-haricots-borlotti': '/fr/recettes',
'/fr/recette/bloggerrecette-chili-con-carne-aux-haricots-rouges-kidney-0': '/fr/recettes',
'/fr/recette/bloggerrecette-salade-de-lentilles-anguille-fumee-et-betteraves-rouges-0': '/fr/recettes',
'/fr/recette/bloggerrecette-wraps-subtilement-aromatises-aux-pois-chiches-0': '/fr/recettes',
'/fr/recette/boeuf-bourguignon-aux-petits-pois': '/fr/recettes',
'/fr/recette/boulettes-aperitives-de-petits-pois': '/fr/recettes',
'/fr/recette/boulettes-la-sauce-tomates-aux-pois-chiches': '/fr/recettes',
'/fr/recette/brochette-de-scampis-et-taboule-aux-fines-herbes-et-au-mais': '/fr/recettes',
'/fr/recette/brochettes-de-hachis-la-turc-avec-sauce-aux-haricots-borlotti': '/fr/recettes',
'/fr/recette/bruschetta-aux-scampis-et-salsa-lavocat-et-haricots': '/fr/recettes',
'/fr/recette/bruschetta-la-ratatouille': '/fr/recettes',
'/fr/recette/burrito-au-poulet-et-aux-haricots-rouges': '/fr/recettes',
'/fr/recette/cabillaud-aux-lentilles-chaudes-et-petite-salade-depinards': '/fr/recettes',
'/fr/recette/cabillaud-la-choucroute-et-aux-haricots-geants': '/fr/recettes',
'/fr/recette/chile-con-carne-express': '/fr/recettes',
'/fr/recette/chili-de-poisson-au-chorizo': '/fr/recettes',
'/fr/recette/cotelettes-de-porc-et-salade-de-haricots-blancs': '/fr/recettes',
'/fr/recette/couscous-au-poulet-abricots-et-pois-chiches': '/fr/recettes',
'/fr/recette/couscous-corse-aux-dattes-noix-et-flageolets': '/fr/recettes',
'/fr/recette/couscous-vegetarien-hollandais': '/fr/recettes',
'/fr/recette/croissants-grecs-aux-flageolets-et-la-menthe': '/fr/recettes',
'/fr/recette/crostini-aux-haricots-cannellini-et-aux-anchois': '/fr/recettes',
'/fr/recette/crostini-la-sauce-aux-haricots-borlotti': '/fr/recettes',
'/fr/recette/curry-aux-pois-chiches-avec-poulet-et-pain-naan': '/fr/recettes',
'/fr/recette/curry-de-haricots-express-aux-haricots-cannellini': '/fr/recettes',
'/fr/recette/curry-de-lentilles-indien': '/fr/recettes',
'/fr/recette/curry-de-poisson-thai-aux-haricots-rouges-avec-poireaux-et-coriandre': '/fr/recettes',
'/fr/recette/daube-campagnarde-espagnole-aux-pois-chiches': '/fr/recettes',
'/fr/recette/daube-de-poulet-avec-feves-et-lardons': '/fr/recettes',
'/fr/recette/daube-mediterraneenne-de-viande-et-de-poisson': '/fr/recettes',
'/fr/recette/dips-de-legumes-frais': '/fr/recettes',
'/fr/recette/feuillete-la-ratatouille-et-mozzarella': '/fr/recettes',
'/fr/recette/galettes-de-mais-et-tzatziki': '/fr/recettes',
'/fr/recette/gateau-de-crepes-aux-haricots-rouges-kidney-sucres': '/fr/recettes',
'/fr/recette/gnocchi-avec-champignons-et-haricots-verts': '/fr/recettes',
'/fr/recette/hachis-parmentier-aux-lentilles-et-ricotta': '/fr/recette/r/hachis-parmentier-aux-lentilles-et-ricotta/begp015',
'/fr/recette/hamburger-de-pois-chiches-avec-salade-dananas': '/fr/recettes',
'/fr/recette/houmous': '/fr/recettes',
'/fr/recette/jeunes-pousses-de-salade-et-pomme': '/fr/recettes',
'/fr/recette/laitue-frisee-mangue-et-avocat': '/fr/recettes',
'/fr/recette/laitue-romaine-grillee-et-pois-chiches-rotis': '/fr/recette/r/laitue-romaine-grillee-et-pois-chiches-rotis/begp027',
'/fr/recette/lanieres-de-boeuf-teriyaki-au-tauge-et-aux-haricots-cannellini': '/fr/recettes',
'/fr/recette/le-big-bean-burger': '/fr/recettes',
'/fr/recette/legumes-grilles-au-crispy-mais': '/fr/recette/r/legumes-grilles-au-crispy-mais/begp019',
'/fr/recette/lentilles-piquantes-avec-crevettes-hollandaises': '/fr/recettes',
'/fr/recette/lentilles-tiedes-au-fromage-de-chevre-gratine': '/fr/recettes',
'/fr/recette/maki-cannellini': '/fr/recettes',
'/fr/recette/minestrone-aux-haricots-rouges-et-pancetta': '/fr/recettes',
'/fr/recette/minestrone': '/fr/recettes',
'/fr/recette/muffins-au-mais': '/fr/recettes',
'/fr/recette/paella-au-poulet-et-aux-crevettes': '/fr/recettes',
'/fr/recette/pain-nan-farci-aux-legumes-et-la-saucisse': '/fr/recettes',
'/fr/recette/pain-turc-aux-haricots-geants-et-la-sauce-tomates': '/fr/recettes',
'/fr/recette/pates-la-ratatouille-avec-filet-de-poulet-grille': '/fr/recettes',
'/fr/recette/penne-au-brie-bacon-et-petits-pois': '/fr/recettes',
'/fr/recette/petites-brochettes-de-poulet-et-salsa-arc-en-ciel': '/fr/recette/r/petites-brochettes-de-poulet-et-salsa-arc-en-ciel/begp028',
'/fr/recette/pizza-bello-bono': '/fr/recettes',
'/fr/recette/poke-bowl-riz-(a-sushi)-avocat-et-pois-chiches': '/fr/recettes',
'/fr/recette/poke-bowl-riz-a-sushi-saumon-et-edamame': '/fr/recette/r/poke-bowl-riz-a-sushi-saumon-et-edamame/begp008',
'/fr/recette/poke-bowl-riz-sushi-avocat-et-pois-chiches': '/fr/recettes',
'/fr/recette/poke-bowl-riz-sushi-saumon-et-edamame': '/fr/recettes',
'/fr/recette/poke-bowl-thon-mangue-et-haricots-rouges': '/fr/recette/r/poke-bowl-thon-mangue-et-haricots-rouges/begp010',
'/fr/recette/potee-aux-pois-chiches-et-epinards': '/fr/recettes',
'/fr/recette/potee-aux-pois-chiches-et-poulet': '/fr/recettes',
'/fr/recette/potee-italienne-aux-haricots-borlotti': '/fr/recettes',
'/fr/recette/poule-au-pot-la-noix-de-coco-et-aux-haricots-cannellini': '/fr/recettes',
'/fr/recette/poulet-piquant-aux-lentilles-et-sauce-coco': '/fr/recettes',
'/fr/recette/quiche-aux-epinards-betterave-rouge-fromage-de-chevre-et-lentilles': '/fr/recette/r/quiche-aux-epinards-betterave-rouge-fromage-de-chevre-et-lentilles/begp023',
'/fr/recette/quiche-aux-haricots-rouges-kidney-courgette': '/fr/recettes',
'/fr/recette/quiche-aux-lardons-poireaux-et-haricots-rouges': '/fr/recettes',
'/fr/recette/ragout-de-poireaux-au-fromage-aux-herbes-et-aux-pois-chiches': '/fr/recettes',
'/fr/recette/ragout-de-saucisse-fraiche-et-de-feves': '/fr/recettes',
'/fr/recette/ragout-marocain-aux-haricots-rouges': '/fr/recettes',
'/fr/recette/risotto-au-fromage-et-au-thym-avec-des-feves': '/fr/recettes',
'/fr/recette/risotto-au-mais-et-au-citron-avec-poulet-grille-au-romarin': '/fr/recettes',
'/fr/recette/roulade-de-porc-aux-haricots-borlotti': '/fr/recettes',
'/fr/recette/rouleaux-de-limande-farcis-aux-haricots-cannellini': '/fr/recettes',
'/fr/recette/salade-au-thon-concombre-et-haricots-rouges': '/fr/recette/r/salade-au-thon-concombre-et-haricots-rouges/begp021',
'/fr/recette/salade-cesar-aux-crispy-mais': '/fr/recette/r/salade-cesar-aux-crispy-mais/begp034',
'/fr/recette/salade-cesar-estivale-au-crispy-mais': '/fr/recettes',
'/fr/recette/salade-cesar-paree-de-rouge': '/fr/recette/r/salade-cesar-paree-de-rouge/begp030',
'/fr/recette/salade-de-chicons-aux-pois-chiches': '/fr/recette/r/salade-de-chicons-aux-pois-chiches/begp012',
'/fr/recette/salade-de-couscous-avec-haricots-geants-et-yaourt-labricot': '/fr/recettes',
'/fr/recette/salade-de-couscous-mais-et-lentilles': '/fr/recettes',
'/fr/recette/salade-de-haricots-tricolore-et-dressing-lavocat': '/fr/recettes',
'/fr/recette/salade-de-lentilles-aux-champignons': '/fr/recettes',
'/fr/recette/salade-de-lentilles-avec-roquette-et-fromage-de-chevre': '/fr/recettes',
'/fr/recette/salade-de-lentilles-la-mozzarella-et-aux-tomates': '/fr/recettes',
'/fr/recette/salade-de-mais-et-maquereau': '/fr/recettes',
'/fr/recette/salade-de-pasteque-aux-haricots-feta-et-menthe': '/fr/recette/r/salade-de-pasteque-aux-haricots-feta-et-menthe/begp020',
'/fr/recette/salade-de-pates-au-thon-aux-haricots-cannellini-et-la-salsa-verde': '/fr/recettes',
'/fr/recette/salade-de-pates-avec-mais-mozzarella-et-dressing-aux-fines-herbes': '/fr/recettes',
'/fr/recette/salade-de-pates-mediterraneenne-au-crispy-mais': '/fr/recettes',
'/fr/recette/salade-de-pesto-au-mais-et-haricots': '/fr/recette/r/salade-de-pesto-au-mais-et-haricots/begp032',
'/fr/recette/salade-de-pois-chiches-au-fromage-et-la-menthe': '/fr/recettes',
'/fr/recette/salade-de-pommes-de-terre-grenaille-aux-haricots-borlotti-et-la-mayonnaise-epicee': '/fr/recettes',
'/fr/recette/salade-de-pommes-de-terre-grenaille-et-mais-sauce-aux-herbes': '/fr/recettes',
'/fr/recette/salade-de-poulet-mais-et-haricots-rouges-kidney-sauce-lavocat': '/fr/recettes',
'/fr/recette/salade-de-riz-mais-et-pomme-sauce-au-curry': '/fr/recettes',
'/fr/recette/salade-de-riz-piquant': '/fr/recettes',
'/fr/recette/salade-de-roquette-au-gorgonzola': '/fr/recettes',
'/fr/recette/salade-depinards-aux-haricots-rouges-kidney-lorange-et-la-feta': '/fr/recettes',
'/fr/recette/salade-depinards-la-grec-aux-haricots-geants-et-la-feta': '/fr/recettes',
'/fr/recette/salade-d�epinards-aux-haricots-rouges-kidney-a-l�orange-et-a-la-feta': '/fr/recettes',
'/fr/recette/salade-energie': '/fr/recettes',
'/fr/recette/salade-fraiche-de-pois-chiches-avec-grenade': '/fr/recettes',
'/fr/recette/salade-guacamole-au-crispy-mais': '/fr/recette/r/salade-guacamole-au-crispy-mais/begp018',
'/fr/recette/salade-italienne-de-pates-et-mais-sauce-au-basilic': '/fr/recettes',
'/fr/recette/salade-liegeoise-aux-pois-chiches': '/fr/recette/r/salade-liegeoise-aux-pois-chiches/begp035',
'/fr/recette/salade-mediterraneenne-aux-haricots-cannellini': '/fr/recettes',
'/fr/recette/salade-nicoise': '/fr/recettes',
'/fr/recette/salade-romaine-au-thon': '/fr/recettes',
'/fr/recette/salade-toscane-aux-haricots-borlotti-et-au-jambon-de-parme': '/fr/recettes',
'/fr/recette/samossa-indien': '/fr/recettes',
'/fr/recette/sauce-trempette-petits-pois-la-menthe': '/fr/recettes',
'/fr/recette/sauce-trempette-pois-chiches-et-maquereau-avec-nachos': '/fr/recettes',
'/fr/recette/souffle-de-petits-pois': '/fr/recettes',
'/fr/recette/soupe-aux-nouilles-avec-flageolets-et-lanieres-de-porc': '/fr/recettes',
'/fr/recette/soupe-de-cannellini-cremeuse-au-curry-de-crevettes': '/fr/recettes',
'/fr/recette/soupe-de-courge-rotie-aux-lentilles': '/fr/recettes',
'/fr/recette/soupe-de-haricots-geants': '/fr/recettes',
'/fr/recette/soupe-de-lentilles-au-paprika': '/fr/recettes',
'/fr/recette/soupe-de-mais-aux-oignons-de-printemps-et-lanieres-de-poulet': '/fr/recettes',
'/fr/recette/soupe-de-pois-chiches-avec-de-la-creme-dail': '/fr/recettes',
'/fr/recette/soupe-italienne-aux-haricots-borlotti-et-la-pancetta': '/fr/recettes',
'/fr/recette/spaghettis-au-pesto-rouge-et-aux-haricots-geants': '/fr/recettes',
'/fr/recette/tajine-dagneau-aux-haricots-blancs': '/fr/recettes',
'/fr/recette/tajine-dagneau-aux-pois-chiches': '/fr/recettes',
'/fr/recette/tapenade-de-lentilles': '/fr/recettes',
'/fr/recette/tarte-salee-aux-legumes': '/fr/recettes',
'/fr/recette/tartelettes-aux-carottes': '/fr/recettes',
'/fr/recette/tasty-sate': '/fr/recettes',
'/fr/recette/tortilla-au-poulet-haricots-mais-et-salsa-aux-pommes': '/fr/recette/r/tortilla-au-poulet-haricots-mais-et-salsa-aux-pommes/begp033',
'/fr/recette/tortilla-aux-haricots-rouges-et-lardons': '/fr/recettes',
'/fr/recette/tortilla-la-pomme-de-terre-et-au-mais-avec-du-chorizo': '/fr/recettes',
'/fr/recette/tortilla-pizza-coloree': '/fr/recette/r/tortilla-pizza-coloree/begp031',
'/fr/recette/tourte-de-poisson-aux-epinards-et-aux-petits-poids': '/fr/recettes',
'/fr/recette/tzatziki-aux-pois-chiches-avec-poulet-grille': '/fr/recette/r/tzatziki-aux-pois-chiches-avec-poulet-grille/begp024',
'/fr/recette/veloute-dendives-aux-haricots-canellini': '/fr/recettes',
'/fr/recette/waterzooi-la-gantoise-aux-pois-chiches': '/fr/recettes',
'/fr/recette/wrap-au-guacamole-et-haricots-rouges-kidney': '/fr/recettes',
'/fr/recette/wrap-au-poulet-mais-et-guacamole-maison': '/fr/recettes',
'/fr/recette/wrap-du-cow-boy': '/fr/recettes',
'/fr/recettes' :  '/fr',
'/fr/recettes/cherchez' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/asiatique' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/asiatique?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/mediterraneenne?page=5' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/moyen-orient' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/moyen-orient?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/moyen-orient?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=5' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/occidentale?page=6' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/sud-americaine' :  '/fr',
'/fr/recettes/cherchez/categorie/cuisine/sud-americaine?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/bouchees' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/bouchees?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/fetes' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/fetes?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=5' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/monde?page=6' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/snack-time' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/snack-time?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/snack-time?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/spicy' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/spicy?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/spicy?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/super-salads' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/super-salads?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/super-salads?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/super-salads?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/viva-la-vega' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/viva-la-vega?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/viva-la-vega?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/viva-la-vega?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/mood/viva-la-vega?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/accompagnement' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/accompagnement?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/accompagnement?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/accompagnement?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/dessert' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/en-cas' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/en-cas?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/en-cas?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/entree' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/entree?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/entree?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/entree?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/lunch' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/lunch?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/lunch?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/lunch?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/lunch?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=5' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=6' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=7' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=8' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/plat-principal?page=9' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-plat/soupe' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/pates' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/pates?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/poissons' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/poissons?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/poissons?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/riz' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=4' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=5' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/vegetarien?page=6' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/viande' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/viande?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/viande?page=2' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/viande?page=3' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/volaille' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/volaille?page=1' :  '/fr',
'/fr/recettes/cherchez/categorie/type-de-preparation/volaille?page=2' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=1' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=10' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=11' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=12' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=13' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=14' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=15' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=2' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=3' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=4' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=5' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=6' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=7' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=8' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=&page=9' :  '/fr',
'/fr/recettes/cherchez?category%252Fmood%252Fbest-of-beans=' :  '/fr',
'/fr/recettes/cherchez?page=1' :  '/fr',
'/fr/recettes/cherchez?page=10' :  '/fr',
'/fr/recettes/cherchez?page=11' :  '/fr',
'/fr/recettes/cherchez?page=12' :  '/fr',
'/fr/recettes/cherchez?page=13' :  '/fr',
'/fr/recettes/cherchez?page=14' :  '/fr',
'/fr/recettes/cherchez?page=15' :  '/fr',
'/fr/recettes/cherchez?page=2' :  '/fr',
'/fr/recettes/cherchez?page=3' :  '/fr',
'/fr/recettes/cherchez?page=4' :  '/fr',
'/fr/recettes/cherchez?page=5' :  '/fr',
'/fr/recettes/cherchez?page=6' :  '/fr',
'/fr/recettes/cherchez?page=7' :  '/fr',
'/fr/recettes/cherchez?page=8' :  '/fr',
'/fr/recettes/cherchez?page=9' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=1' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=10' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=11' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=12' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=13' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=14' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=15' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=2' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=3' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=4' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=5' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=6' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=7' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=8' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=9' :  '/fr',
'/fr/recettes/cherchez?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All' :  '/fr',
'/fr/sites/all/themes/bonduelle/img/jet-kookt-met/hero.jpg' :  '/fr',
'/fr/user' :  '/fr',
'/fr/user/password' :  '/fr',
'/fr/user/register' :  '/fr',
'/jet-kookt-met' :  '/nl',
'/nl/gebruiksvoorwaarden' :  '/nl',
'/nl/groente/aubergine' :  '/nl/producten/groenten/aubergine',
'/nl/groente/borlottiboon' :  '/nl',
'/nl/groente/boterboon' :  '/nl/producten/p/boterboontjes-zeer-fijn/03083680600835',
'/nl/groente/cannelliniboon' :  '/nl/producten/p/cannellini-bonen/03083681003901',
'/nl/groente/cantharel' :  '/nl',
'/nl/groente/champignon' :  '/nl/producten/p/parijse-champignons-mini/03083681005783',
'/nl/groente/courgette' :  '/nl',
'/nl/groente/doperwt' :  '/nl/producten/p/doperwtjes-extra-fijn/03083681012705',
'/nl/groente/groene-kidneyboon' :  '/nl/producten/p/groene-peulbonen/03083680613354',
'/nl/groente/kikkererwt' :  '/nl/producten/p/kikkererwten/03083681012668',
'/nl/groente/linzen' :  '/nl/producten/p/linzen/03083681012644',
'/nl/groente/mais' :  '/fr/recette/legume/mais',
'/nl/groente/oesterzwam' :  '/nl/producten/p/parijse-champignons-et-oesterzwammen/03083681005851',
'/nl/groente/reuzenboon' :  '/nl/producten/p/reuzenbonen/03083681012620',
'/nl/groente/rode-kidneyboon' :  '/nl/producten/p/rode-kidneybonen/03083681012583',
'/nl/groente/rode-kool' :  '/nl',
'/nl/groente/sperzieboon' :  '/nl/producten/p/gebroken-sperzieboontjes/03083680613750',
'/nl/groente/spinazie' :  '/nl/producten/groenten/spinazie',
'/nl/groente/tuinboon' :  '/nl/producten/p/tuinboontjes/03083681012521',
'/nl/groente/witte-boon' :  '/nl/producten/p/witte-bonen/03083681023268',
'/nl/groente/wortel' :  '/nl/producten/p/worteltjes-extra-fijn/03083680613866',
'/nl/groente/zwarte-boon' :  '/nl/producten/p/zwarte-bonen/03083681007800',
'/nl/groenten' :  '/nl/producten',
'/nl/groenten-met-meer-bite' :  '/nl',
'/nl/groenten?page=1' :  '/nl',
'/nl/jet-kookt-met' :  '/nl',
'/nl/node/299' :  '/nl',
'/nl/node/313' :  '/nl',
'/nl/onze-groenten': '/nl/producten',
'/nl/over-bonduelle' :  '/nl/over-ons/nieuws',
'/nl/over-bonduelle/geschiedenis' :  '/nl/over-ons/geschiedenis',
'/nl/over-bonduelle/jobs' :  '/nl',
'/nl/over-bonduelle/proces' :  '/nl/over-ons/nieuws',
'/nl/over-ons/innovaties': '/nl/over-ons/innovatie',
'/nl/over-ons/onze-betrokkenheid': '/nl/over-ons/mvo',
'/nl/over-ons/onze-geschiedenis': '/nl/over-ons/geschiedenis',
'/nl/privacy-statement' :  '/nl/privacybeleid',
'/nl/product/aubergines-la-provencale' :  '/nl/producten/p/aubergines-a-la-provencale/03083681009743',
'/nl/product/black-eyed-bonen' :  '/nl',
'/nl/product/borlotti-bonen' :  '/nl/producten/p/borlotti-bonen/03083681003925',
'/nl/product/boterboontjes-zeer-fijn' :  '/nl/producten/p/boterboontjes-zeer-fijn/03083680600835',
'/nl/product/cannellinibonen' :  '/nl/producten/p/cannellini-bonen/03083681003901',
'/nl/product/courgettes-à-la-provençale' :  '/nl',
'/nl/product/crispy-ma%C3%A9s' :  '/nl/producten/p/crispy-mais-2-mini-packs-srp/03083681068184',
'/nl/product/crispy-ma%C3%A9s-bio' :  '/nl/producten/p/crispy-mais-bio/03083681002416',
'/nl/product/crispy-mais-mini-packs' :  '/nl/producten/p/crispy-mais/03083680597210',
'/nl/product/doperwtjes-extra-fijn' :  '/nl/producten/p/doperwtjes-extra-fijn/03083681012705',
'/nl/product/doperwtjes-extra-fijn-0' :  '/nl/producten/p/doperwtjes-extra-fijn/03083681012729',
'/nl/product/doperwtjes-festini' :  '/nl/producten/p/doperwtjes-festini/03083680597142',
'/nl/product/doperwtjes-worteltjes-extra-fijn' :  '/nl/producten/p/doperwtjes-et-worteltjes-extra-fijn/03083681028485',
'/nl/product/doperwtjes-worteltjes-extra-fijn-0' :  '/nl/producten/p/doperwtjes-et-worteltjes-extra-fijn/03083681028485',
'/nl/product/doperwtjes-worteltjes-zeer-fijn' :  '/nl/producten/p/doperwtjes-et-worteltjes-zeer-fijn/03083681012804',
'/nl/product/doperwtjes-zeer-fijn' :  '/nl',
'/nl/product/edamame-bonen-mini-packs' :  '/nl/producten/p/edamame-bonen-2-mini-packs-srp/03083681079647',
'/nl/product/fantasia-ma%C3%A9s-fiesta-sperzieboontjes-paprika' :  '/nl',
'/nl/product/fantasia-ma%C3%A9s-salsa-rode-kidneyboontjes-paprika' :  '/nl',
'/nl/product/franse-bleekselderijharten' :  '/nl/producten/p/franse-bleekselderijharten/03083680600873',
'/nl/product/franse-sperzieboontjes-zeer-fijn' :  '/nl/producten/p/franse-sperzieboontjes-zeer-fijn-gerangschikt/03083680534796',
'/nl/product/franse-sperzieboontjes-zeer-fijn-gerangschikt' :  '/nl/producten/p/franse-sperzieboontjes-zeer-fijn-gerangschikt/03083680534796',
'/nl/product/gebroken-sperzieboontjes' :  '/nl/producten/p/gebroken-sperzieboontjes/03083680613750',
'/nl/product/gehakte-spinazie' :  '/nl/producten/p/spinazie-gehakt/03083680001243',
'/nl/product/groene-peulbonen' :  '/nl/producten/p/groene-peulbonen/03083680613354',
'/nl/product/groentepannetje-op-parijse-wijze' :  '/nl',
'/nl/product/groentepannetje-op-vlaamse-wijze' :  '/nl',
'/nl/product/haricots-verts-extra-fijn-gerangschikt' :  '/nl/producten/p/haricots-verts-extra-fijn-gerangschikt/03083680597135',
'/nl/product/haricots-verts-extra-fijn-gerangschikt-0' :  '/nl/producten/p/haricots-verts-extra-fijn-gerangschikt/03083680597135',
'/nl/product/haricots-verts-miniatuur' :  '/nl',
'/nl/product/kervel' :  '/nl/producten/groenten/kervel',
'/nl/product/kikkererwten' :  '/nl/producten/p/kikkererwten-bio/03083681052848',
'/nl/product/kikkererwten-bio' :  '/nl/producten/p/kikkererwten-2-mini-packs-srp/03083681068146',
'/nl/product/kikkererwten-mini-packs' :  '/nl/producten/p/kikkererwten/03083681012668',
'/nl/product/krielaardappeltjes' :  '/nl/producten/p/krielaardappeltjes/03083681005356',
'/nl/product/linzen' :  '/nl/producten/p/linzen/03083681012644',
'/nl/product/mac%C3%A9doine-de-l%C3%A9gumes' :  '/nl/producten/p/macedoine-de-legumes/03083680600910',
'/nl/product/macedoine-de-legumes-0' :  '/nl/producten/p/macedoine-de-legumes/03083680600910',
'/nl/product/mais-voor-salade' :  '/nl/producten/p/mais-voor-salade/03083681034646',
'/nl/product/mexico-m%C3%A9lange' :  '/nl/producten/p/mexico-melange/03083680012362',
'/nl/product/parijse-champignons-cantharellen' :  '/nl',
'/nl/product/parijse-champignons-gesneden' :  '/nl',
'/nl/product/parijse-champignons-mini' :  '/nl/producten/p/parijse-champignons-mini/03083681005783',
'/nl/product/parijse-champignons-oesterzwammen' :  '/nl/producten/p/parijse-champignons-et-oesterzwammen/03083681005851',
'/nl/product/pruimen-op-siroop' :  '/nl/producten/p/pruimen-op-siroop/03083680020411',
'/nl/product/ratatouille-la-provencale' :  '/nl/producten/p/ratatouille-a-la-provencale/03083681009767',
'/nl/product/reuzenbonen' :  '/nl/producten/p/reuzenbonen/03083681012620',
'/nl/product/rode-kidneybonen' :  '/nl/producten/p/rode-kidneybonen/03083681012583',
'/nl/product/rode-kidneybonen-mini-packs' :  '/nl/producten/p/rode-kidneybonen/03083681012606',
'/nl/product/rode-kindeybonen-bio' :  '/nl/producten/p/rode-kidneybonen-bio/03083681052831',
'/nl/product/rode-kool-met-appel' :  '/nl',
'/nl/product/tuinboontjes' :  '/nl/producten/p/tuinboontjes/03083681012521',
'/nl/product/witte-bonen' :  '/nl/producten/p/witte-bonen-in-tomatensaus/03083680010726',
'/nl/product/witte-bonen-tomatensaus' :  '/nl/producten/p/witte-bonen/03083681023268',
'/nl/product/wortelschijfjes' :  '/nl/producten/p/wortelschijfjes/03083681005332',
'/nl/product/worteltjes-extra-fijn' :  '/nl/producten/p/worteltjes-extra-fijn/03083680613866',
'/nl/product/zurkel' :  '/nl/producten/p/zurkel/03083680594172',
'/nl/product/zwarte-bonen' :  '/nl/producten/p/zwarte-bonen-2-mini-packs-srp/03083681068191',
'/nl/product/zwarte-bonen-mini-packs' :  '/nl/producten/p/zwarte-bonen/03083681007800',
'/nl/producten' :  '/nl/producten',
'/nl/producten/bonenpasta-rijst': '/nl/producten/groentepasta-rijst',
'/nl/producten/zoeken/trefwoord/paarse%2Blogo' :  '/nl/producten',
'/nl/producten?page=1' :  '/nl/producten',
'/nl/producten?page=2' :  '/nl/producten?p=2',
'/nl/producten?page=3' :  '/nl/producten?p=3',
'/nl/producten?page=4' :  '/nl/producten?p=4',
'/nl/recept/aardappel-maistortilla-met-chorizo' :  '/nl/recept',
'/nl/recept/avocado-salade-met-crispy-mais-en-grijze-garnalen' :  '/nl/recept/r/avocado-salade-met-crispy-mais-en-grijze-garnalen/nlgp063',
'/nl/recept/balletjes-tomatensaus-met-kikkererwtjes' :  '/nl/recept',
'/nl/recept/big-bean' :  '/nl/recept',
'/nl/recept/bitterballen-van-doperwtjes' :  '/nl/recept',
'/nl/recept/bladerdeeghapje-met-ratatouille-en-mozzarella' :  '/nl/recept',
'/nl/recept/bloggergerecht-chili-con-carne-met-rode-kidney-bonen' :  '/nl/recept',
'/nl/recept/bloggergerecht-heerlijk-hartige-wraps-met-kikkererwten' :  '/nl/recept',
'/nl/recept/bloggergerecht-salade-met-linzen-gerookte-forel-en-rode-biet' :  '/nl/recept',
'/nl/recept/boeuf-bourgignon-met-doperwtjes' :  '/nl/recept',
'/nl/recept/brochette-van-scampi-en-taboule-met-mais' :  '/nl/recept',
'/nl/recept/bruschetta-met-kidneybonen-en-gegrilde-paprika' :  '/nl/recept/r/bruschetta-met-kidneybonen-en-gegrilde-paprika/nlgp047',
'/nl/recept/bruschetta-met-ratatouille' :  '/nl/recept',
'/nl/recept/bruschetta-met-scampi-en-bonen-avocado-salsa' :  '/nl/recept/r/bruschetta-met-scampi-en-bonen-avocado-salsa/nlgp067',
'/nl/recept/burrito-met-kip-en-kidneybonen' :  '/nl/recept',
'/nl/recept/caesar-salade-met-crispy-mais' :  '/nl/recept/r/caesar-salade-met-crispy-mais/nlgp080',
'/nl/recept/caesarsalade-met-een-rode-twist' :  '/nl/recept/r/caesarsalade-met-een-rode-twist/nlgp075',
'/nl/recept/caribbean-plaattaart-met-kidneybonen-mais-en-kaas' :  '/nl/recept/r/caribbean-plaattaart-met-kidneybonen-mais-en-kaas/nlgp030',
'/nl/recept/chili-sin-carne' :  '/nl/recept/r/chili-sin-carne/nlgp045',
'/nl/recept/citroen-maisrisotto-met-gegrilde-rozemarijnkip' :  '/nl/recept',
'/nl/recept/couscous-met-kip-abrikozen-en-kikkererwten' :  '/nl/recept',
'/nl/recept/couscoussalade-met-mais-en-linzen' :  '/nl/recept',
'/nl/recept/couscoussalade-met-reuzenbonen-en-abrikozenyoghurt' :  '/nl/recept',
'/nl/recept/cowboywrap' :  '/nl/recept',
'/nl/recept/crostini-met-cannellini-bonen-en-ansjovis' :  '/nl/recept',
'/nl/recept/crostini-met-rode-kidneybonen-salsa' :  '/nl/recept',
'/nl/recept/doperwtensouffle' :  '/nl/recept',
'/nl/recept/frisse-doperwtdip-met-munt' :  '/nl/recept',
'/nl/recept/frisse-kikkererwtensalade-met-granaatappel' :  '/nl/recept',
'/nl/recept/gegrilde-asperges-met-mais-black-eyed-bonen-en-croutons' :  '/nl/recept/r/gegrilde-asperges-met-mais-black-eyed-bonen-en-croutons/nlgp070',
'/nl/recept/gegrilde-romeinse-sla-met-geroosterde-kikkererwten' :  '/nl/recept/r/gegrilde-romeinse-sla-met-geroosterde-kikkererwten/nlgp072',
'/nl/recept/gentse-waterzooi-met-kikkererwten' :  '/nl/recept',
'/nl/recept/geroosterde-pompoensoep-met-linzen' :  '/nl/recept',
'/nl/recept/gevuld-naanbrood-met-groenten-en-worst' :  '/nl/recept',
'/nl/recept/gevulde-aubergine-met-rode-kidneybonen' :  '/nl/recept',
'/nl/recept/gevulde-scholrolletjes-met-cannellinibonen' :  '/nl/recept',
'/nl/recept/gezonde-tonijnsalade-met-komkommer-en-rode-bonen' :  '/nl/recept/r/gezonde-tonijnsalade-met-komkommer-en-rode-bonen/nlgp066',
'/nl/recept/gnocchi-met-champignons-en-haricots-verts' :  '/nl/recept',
'/nl/recept/griekse-pakketjes-met-tonijn-en-groene-kidneybonen' :  '/nl/recept',
'/nl/recept/griekse-spinaziesalade-met-reuzenbonen-en-feta' :  '/nl/recept',
'/nl/recept/hartige-groentetaart' :  '/nl/recept',
'/nl/recept/hollandse-vegetarische-couscous' :  '/nl/recept',
'/nl/recept/hummus' :  '/nl/recept',
'/nl/recept/indiase-linzencurry' :  '/nl/recept',
'/nl/recept/indiase-samosa' :  '/nl/recept',
'/nl/recept/italiaanse-pastasalade-met-mais-en-basilicumdressing' :  '/nl/recept',
'/nl/recept/italiaanse-soep-met-rode-kidneybonen-en-pancetta' :  '/nl/recept',
'/nl/recept/italiaanse-stoofschotel-met-rode-kidneybonen' :  '/nl/recept',
'/nl/recept/kaas-tijmrisotto-met-tuinboontjes' :  '/nl/recept',
'/nl/recept/kabeljauw-met-warme-linzen-en-een-spinazieslaatje' :  '/nl/recept/r/kabeljauw-met-warme-linzen-en-een-spinazieslaatje/nlgp074',
'/nl/recept/kabeljauw-met-zuurkool-en-reuzenbonen' :  '/nl/recept',
'/nl/recept/kikkererwten-makreeldip-met-nachos' :  '/nl/recept',
'/nl/recept/kikkererwtencurry-met-kip-en-naanbrood' :  '/nl/recept',
'/nl/recept/kikkererwtenhamburger-met-ananassalsa' :  '/nl/recept',
'/nl/recept/kikkererwtensalade-met-komijnekaas-en-munt' :  '/nl/recept',
'/nl/recept/kikkererwtensoep-met-knoflookroom' :  '/nl/recept',
'/nl/recept/kikkererwtentzatziki-met-gegrilde-kip' :  '/nl/recept/r/kikkererwtentzatziki-met-gegrilde-kip/nlgp069',
'/nl/recept/kippenpotje-met-tuinboontjes-en-spek' :  '/nl/recept',
'/nl/recept/kippotje-met-kokos-en-cannellinibonen' :  '/nl/recept',
'/nl/recept/kipsalade-met-mais-kidneybonen-en-avocadodressing' :  '/nl/recept',
'/nl/recept/kipspiesjes-met-regenboogsalsa' :  '/nl/recept/r/kipspiesjes-met-regenboogsalsa/nlgp073',
'/nl/recept/kleurrijke-tortilla-pizza' :  '/nl/recept/r/kleurrijke-tortilla-pizza/nlgp076',
'/nl/recept/krieltjessalade-met-mais-en-kruidendressing' :  '/nl/recept',
'/nl/recept/krieltjessalade-met-rode-kidneybonen-en-kruidenmayo' :  '/nl/recept',
'/nl/recept/kruidige-couscous-met-dadels-noten-en-groene-kidneybonen' :  '/nl/recept',
'/nl/recept/krulsla-met-mango-en-avocado' :  '/nl/recept',
'/nl/recept/lauwwarme-linzen-met-gegratineerde-geitenkaas' :  '/nl/recept',
'/nl/recept/linzensalade-met-mozzarella-en-tomaat' :  '/nl/recept/r/linzensalade-met-mozzarella-en-tomaat/nlgp091',
'/nl/recept/linzensalade-met-paddenstoelen' :  '/nl/recept',
'/nl/recept/linzensalade-met-rucola-en-geitenkaas' :  '/nl/recept',
'/nl/recept/linzensoep-met-paprika' :  '/nl/recept',
'/nl/recept/luikse-salade-met-kikkererwten' :  '/nl/recept',
'/nl/recept/maaltijdsoep-van-reuzenbonen' :  '/nl/recept',
'/nl/recept/maiskoekjes-met-tzatziki' :  '/nl/recept',
'/nl/recept/maismuffins' :  '/nl/recept',
'/nl/recept/maissoep-met-lente-uitjes-en-kipreepjes' :  '/nl/recept',
'/nl/recept/maki-cannellini' :  '/nl/recept',
'/nl/recept/marokkaanse-stoofpot-met-rode-bonen' :  '/nl/recept',
'/nl/recept/mediterraans-vlees-en-vispotje' :  '/nl/recept',
'/nl/recept/mediterraanse-pastasalade-met-crispy-mais' :  '/nl/recept',
'/nl/recept/mediterrane-salade-met-cannellinibonen' :  '/nl/recept',
'/nl/recept/minestrone-soep' :  '/nl/recept',
'/nl/recept/minestronesoep-met-rode-kidneybonen-en-pancetta' :  '/nl/recept',
'/nl/recept/noedelsoep-met-varkensreepjes-en-groene-kidneybonen' :  '/nl/recept',
'/nl/recept/pannenkoekentaart-met-zoete-kidneybonen' :  '/nl/recept',
'/nl/recept/parmentierschotel-met-linzen-en-ricotta' :  '/nl/recept',
'/nl/recept/pasta-ratatouille-met-gegrilde-kipfilet' :  '/nl/recept',
'/nl/recept/pastasalade-met-mais-mozzarella-en-tuinkruidendressing' :  '/nl/recept',
'/nl/recept/pastasalade-met-tonijn-en-cannelinibonen' :  '/nl/recept',
'/nl/recept/penne-met-brie-bacon-en-doperwtjes' :  '/nl/recept',
'/nl/recept/pesto-salade-met-mais-en-bonen' :  '/nl/recept/r/pesto-salade-met-mais-en-bonen/nlgp077',
'/nl/recept/pikante-rijstsalade' :  '/nl/recept',
'/nl/recept/pittige-kip-met-linzen-kokossaus' :  '/nl/recept',
'/nl/recept/pittige-linzen-met-hollandse-garnaaltjes' :  '/nl/recept',
'/nl/recept/pizza-bello-bono' :  '/nl/recept',
'/nl/recept/poke-bowl-met-peulvruchten-avocado-en-frisse-limoenvinaigrette' :  '/nl/recept/r/poke-bowl-met-peulvruchten-avocado-en-frisse-limoenvinaigrette/nlgp046',
'/nl/recept/poke-bowl-met-sushirijst-avocado-en-kikkererwten' :  '/nl/recept',
'/nl/recept/poke-bowl-met-sushirijst-zalm-en-edamame' :  '/nl/recept/r/poke-bowl-met-sushirijst-zalm-en-edamame/nlgp021',
'/nl/recept/poke-bowl-met-tonijn-kidneybonen-en-mango' :  '/nl/recept/r/poke-bowl-met-tonijn-kidneybonen-en-mango/nlgp023',
'/nl/recept/power-salad' :  '/nl/recept',
'/nl/recept/preistoofpotje-met-kruidenkaas-en-kikkererwten' :  '/nl/recept',
'/nl/recept/preitortilla-met-rode-kidneybonen-en-spekjes' :  '/nl/recept',
'/nl/recept/quiche-met-rode-kidneybonen-courgette' :  '/nl/recept',
'/nl/recept/quiche-met-spekjes-prei-en-rode-kidneybonen' :  '/nl/recept',
'/nl/recept/quiche-met-spinazie-rode-biet-geitenkaas-en-linzen' :  '/nl/recept/r/quiche-met-spinazie-rode-biet-geitenkaas-en-linzen/nlgp068',
'/nl/recept/rijstsalade-met-mais-appel-en-kerriedressing' :  '/nl/recept',
'/nl/recept/romeinse-salade-met-tonijn' :  '/nl/recept',
'/nl/recept/romige-cannellinisoep-met-currygarnalen' :  '/nl/recept',
'/nl/recept/rucola-salade-met-gorgonzola' :  '/nl/recept',
'/nl/recept/runderreepjes-teriyaki-met-cannellinibonen' :  '/nl/recept',
'/nl/recept/salade-met-mais-en-appeltjes' :  '/nl/recept',
'/nl/recept/salade-met-mais-en-makreel' :  '/nl/recept',
'/nl/recept/salade-nicoise' :  '/nl/recept',
'/nl/recept/salade-van-gegrilde-groenten-en-crispy-mais' :  '/nl/recept',
'/nl/recept/snelle-bonencurry-met-cannellinibonen' :  '/nl/recept',
'/nl/recept/snelle-chili-con-carne' :  '/nl/recept',
'/nl/recept/spaanse-boerenstoofpot-met-kikkererwten' :  '/nl/recept',
'/nl/recept/spaghetti-met-rode-pesto-en-reuzenbonen' :  '/nl/recept',
'/nl/recept/spinaziesalade-met-kidneybonen-sinaasappel-en-feta' :  '/nl/recept/r/spinaziesalade-met-kidneybonen-sinaasappel-en-feta/nlgp044',
'/nl/recept/stoofpotje-met-kikkererwten-en-spinazie' :  '/nl/recept',
'/nl/recept/stoofpotje-van-kikkererwten-met-kip' :  '/nl/recept/r/stoofpotje-van-kikkererwten-met-kip/nlgp090',
'/nl/recept/stoofschotel-met-verse-worst-en-tuinbonen' :  '/nl/recept',
'/nl/recept/tajine-van-lam-met-witte-bonen' :  '/nl/recept',
'/nl/recept/tapenade-van-linzen' :  '/nl/recept',
'/nl/recept/tasty-sate' :  '/nl/recept',
'/nl/recept/thaise-viscurry-met-rode-kidneybonen-prei-en-koriander' :  '/nl/recept',
'/nl/recept/tortilla-met-kip-bonen-mais-en-een-frisse-appel-salsa' :  '/nl/recept/r/tortilla-met-kip-bonen-mais-en-een-frisse-appel-salsa/nlgp078',
'/nl/recept/toscaanse-salade-met-rode-kidneybonen-en-parmaham' :  '/nl/recept',
'/nl/recept/tricolore-boontjessalade-met-avocadodressing' :  '/nl/recept/r/tricolore-boontjessalade-met-avocadodressing/nlgp071',
'/nl/recept/turks-brood-met-reuzenbonen-tomatensaus' :  '/nl/recept',
'/nl/recept/turkse-gehaktspies-met-rode-kidneybonen-dressing' :  '/nl/recept',
'/nl/recept/varkenskoteletten-met-een-frisse-witte-bonensalade' :  '/nl/recept',
'/nl/recept/varkensrollade-uit-de-oven-met-rode-kidneybonen' :  '/nl/recept',
'/nl/recept/veggie-dippers' :  '/nl/recept',
'/nl/recept/veggie-eggie' :  '/nl/recept/r/veggie-eggie/nlgp031',
'/nl/recept/vis-chili-met-chorizo' :  '/nl/recept',
'/nl/recept/vispastei-met-spinazie-en-doperwtjes' :  '/nl/recept',
'/nl/recept/watermeloensalade-met-bonen-feta-en-munt' :  '/nl/recept/r/watermeloensalade-met-bonen-feta-en-munt/nlgp065',
'/nl/recept/witlofsoep-met-cannellini-bonen' :  '/nl/recept',
'/nl/recept/witloofsalade-met-kikkererwten' :  '/nl/recept',
'/nl/recept/worteltaartjes' :  '/nl/recept',
'/nl/recept/wrap-met-guacamole-en-rode-kidneybonen' :  '/nl/recept/r/wrap-met-guacamole-en-rode-kidneybonen/nlgp095',
'/nl/recept/wrap-met-kip-mais-en-zelfgemaakte-guacamole' :  '/nl/recept',
'/nl/recept/zonnige-caesar-salade-met-crispy-mais' :  '/nl/recept',
'/nl/recepten' :  '/nl/recept',
'/nl/recepten/zoeken' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/gevogelte' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/gevogelte?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/pasta' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/pasta?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/rijst' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/rijst?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=6' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vegetarisch?page=7' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vis' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vlees' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vlees?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vlees?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/gerecht/vlees?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/aziatisch' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/aziatisch?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/mediterraan' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/mediterraan?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/mediterraan?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/mediterraan?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/mediterraan?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/midden-oosten' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/midden-oosten?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=6' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=7' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/westers?page=8' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/zuid-amerikaans' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/keuken/zuid-amerikaans?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/bijgerecht' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/bijgerecht?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/bijgerecht?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=10' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=6' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=7' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=8' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/hoofdgerecht?page=9' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/lunch?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/nagerecht' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/soep' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/tussendoortje' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/tussendoortje?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/tussendoortje?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/voorgerecht' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/voorgerecht?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/voorgerecht?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/voorgerecht?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/menugang/voorgerecht?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/eenhappers' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/eenhappers?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/feestje' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/feestje?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/feestje?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/snack-time' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/snack-time?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/snack-time?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/spicy' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/spicy?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/spicy?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/super-salads' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/super-salads?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/super-salads?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/super-salads?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/viva-la-vega?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=6' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood/werelds?page=7' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=1' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=10' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=11' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=12' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=13' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=14' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=15' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=2' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=3' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=4' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=5' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=6' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=7' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=8' :  '/nl/recept',
'/nl/recepten/zoeken/categorie/mood?page=9' :  '/nl/recept',
'/nl/recepten/zoeken?page=1' :  '/nl/recept',
'/nl/recepten/zoeken?page=10' :  '/nl/recept',
'/nl/recepten/zoeken?page=11' :  '/nl/recept',
'/nl/recepten/zoeken?page=12' :  '/nl/recept',
'/nl/recepten/zoeken?page=13' :  '/nl/recept',
'/nl/recepten/zoeken?page=14' :  '/nl/recept',
'/nl/recepten/zoeken?page=15' :  '/nl/recept',
'/nl/recepten/zoeken?page=2' :  '/nl/recept',
'/nl/recepten/zoeken?page=3' :  '/nl/recept',
'/nl/recepten/zoeken?page=4' :  '/nl/recept',
'/nl/recepten/zoeken?page=5' :  '/nl/recept',
'/nl/recepten/zoeken?page=6' :  '/nl/recept',
'/nl/recepten/zoeken?page=7' :  '/nl/recept',
'/nl/recepten/zoeken?page=8' :  '/nl/recept',
'/nl/recepten/zoeken?page=9' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=1' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=10' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=11' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=12' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=13' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=14' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=15' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=2' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=3' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=4' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=5' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=6' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=7' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=8' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All&page=9' :  '/nl/recept',
'/nl/recepten/zoeken?trefwoord=&menugang=All&keuken=All&gerecht=All&mood=All&bereidingstijd=All' :  '/nl/recept',
'/nl/recettes/cherchez' :  '/nl',
'/nl/recettes/cherchez/categorie/cuisine/asiatique' :  '/nl',
'/nl/recettes/cherchez/categorie/cuisine/mediterraneenne' :  '/nl',
'/nl/recettes/cherchez/categorie/cuisine/moyen-orient' :  '/nl',
'/nl/recettes/cherchez/categorie/cuisine/occidentale' :  '/nl',
'/nl/recettes/cherchez/categorie/cuisine/sud-americaine' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/bouchees' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/fetes' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/monde' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/snack-time' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/snack-time?page=1' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/snack-time?page=2' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/spicy' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/spicy?page=1' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/spicy?page=2' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/super-salads' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/super-salads?page=1' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/super-salads?page=2' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/super-salads?page=3' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega?page=1' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega?page=2' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega?page=3' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega?page=4' :  '/nl',
'/nl/recettes/cherchez/categorie/mood/viva-la-vega?page=5' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/accompagnement' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/dessert' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/en-cas' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/entree' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch?page=1' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch?page=2' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch?page=3' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch?page=4' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/lunch?page=5' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/plat-principal' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-plat/soupe' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/pates' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/poissons' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/riz' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/vegetarien' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/viande' :  '/nl',
'/nl/recettes/cherchez/categorie/type-de-preparation/volaille' :  '/nl',
'/nl/recettes/cherchez?page=1' :  '/nl',
'/nl/recettes/cherchez?page=10' :  '/nl',
'/nl/recettes/cherchez?page=11' :  '/nl',
'/nl/recettes/cherchez?page=12' :  '/nl',
'/nl/recettes/cherchez?page=13' :  '/nl',
'/nl/recettes/cherchez?page=14' :  '/nl',
'/nl/recettes/cherchez?page=15' :  '/nl',
'/nl/recettes/cherchez?page=2' :  '/nl',
'/nl/recettes/cherchez?page=3' :  '/nl',
'/nl/recettes/cherchez?page=4' :  '/nl',
'/nl/recettes/cherchez?page=5' :  '/nl',
'/nl/recettes/cherchez?page=6' :  '/nl',
'/nl/recettes/cherchez?page=7' :  '/nl',
'/nl/recettes/cherchez?page=8' :  '/nl',
'/nl/recettes/cherchez?page=9' :  '/nl',
'/nl/sites/all/themes/bonduelle/img/jet-kookt-met/hero.jpg' :  '/nl',
'/nl/smultip/biefstuk-met-paddenstoelensaus' :  '/nl/recept',
'/nl/smultip/biefstuk-met-paddenstoelensaus/cantharel' :  '/nl/recept',
'/nl/smultip/biefstuk-met-paddenstoelensaus/champignon' :  '/nl/recept',
'/nl/smultip/bladerdeeghapje-met-champignons' :  '/nl/recept',
'/nl/smultip/bladerdeeghapje-met-champignons/champignon' :  '/nl/recept',
'/nl/smultip/borlottiburgers' :  '/nl/recept',
'/nl/smultip/boterboontjes-met-amandelen' :  '/nl/recept',
'/nl/smultip/boterboontjes-met-amandelen/boterboon' :  '/nl/recept',
'/nl/smultip/boterboontjes-op-chinese-wijze' :  '/nl/recept',
'/nl/smultip/boterboontjes-op-chinese-wijze/boterboon' :  '/nl/recept',
'/nl/smultip/champignonpakketje' :  '/nl/recept',
'/nl/smultip/champignonpakketje/cantharel' :  '/nl/recept',
'/nl/smultip/champignonpakketje/champignon' :  '/nl/recept',
'/nl/smultip/champignons-met-een-amandelkorstje' :  '/nl/recept',
'/nl/smultip/champignons-met-een-amandelkorstje/cantharel' :  '/nl/recept',
'/nl/smultip/champignons-met-een-amandelkorstje/champignon' :  '/nl/recept',
'/nl/smultip/champignons-op-chinese-wijze' :  '/nl/recept',
'/nl/smultip/champignons-op-chinese-wijze/champignon' :  '/nl/recept',
'/nl/smultip/champignons-op-chinese-wijze/oesterzwam' :  '/nl/recept',
'/nl/smultip/chillbonen-pittige-saus' :  '/nl/recept',
'/nl/smultip/crispy-ma%C3%A9s-pasta-met-kip' :  '/nl/recept',
'/nl/smultip/crispy-ma%C3%A9s-pasta-met-kip/mais' :  '/nl/recept',
'/nl/smultip/doperwtjes-met-sinaasappel' :  '/nl/recept',
'/nl/smultip/doperwtjes-met-sinaasappel/doperwt' :  '/nl/recept',
'/nl/smultip/doperwtjes-met-venkel' :  '/nl/recept',
'/nl/smultip/doperwtjes-met-venkel/doperwt' :  '/nl/recept',
'/nl/smultip/doperwtjes-op-marokkaanse-wijze' :  '/nl/recept',
'/nl/smultip/doperwtjes-op-marokkaanse-wijze/doperwt' :  '/nl/recept',
'/nl/smultip/doperwtjes-worteltjes-op-zn-grieks' :  '/nl/recept',
'/nl/smultip/doperwtjes-worteltjes-op-zn-grieks/doperwt' :  '/nl/recept',
'/nl/smultip/doperwtjes-worteltjes-op-zn-grieks/wortel' :  '/nl/recept',
'/nl/smultip/frisse-couscoussalade' :  '/nl/recept',
'/nl/smultip/frisse-couscoussalade/groene-kidneyboon' :  '/nl/recept',
'/nl/smultip/frisse-kikkererwtensalade' :  '/nl/recept',
'/nl/smultip/frisse-kikkererwtensalade/kikkererwt' :  '/nl/recept',
'/nl/smultip/frisse-worteltjes-met-appel' :  '/nl/recept',
'/nl/smultip/frisse-worteltjes-met-appel/wortel' :  '/nl/recept',
'/nl/smultip/garnalen-met-cannellinibonen' :  '/nl/recept',
'/nl/smultip/garnalen-met-cannellinibonen/cannelliniboon' :  '/nl/recept',
'/nl/smultip/gebroken-sperzieboontjes-indonesia' :  '/nl/recept',
'/nl/smultip/gebroken-sperzieboontjes-indonesia/sperzieboon' :  '/nl/recept',
'/nl/smultip/gegratineerde-champignons' :  '/nl/recept',
'/nl/smultip/gegratineerde-champignons/champignon' :  '/nl/recept',
'/nl/smultip/gegrilde-groenten-met-kikkererwten' :  '/nl/recept',
'/nl/smultip/gegrilde-groenten-met-kikkererwten/kikkererwt' :  '/nl/recept',
'/nl/smultip/geroosterde-aubergine-met-paddenstoelen' :  '/nl/recept',
'/nl/smultip/geroosterde-aubergine-met-paddenstoelen/champignon' :  '/nl/recept',
'/nl/smultip/geroosterde-aubergine-met-paddenstoelen/oesterzwam' :  '/nl/recept',
'/nl/smultip/gestoofde-doperwtjes-worteltjes-met-crème-fraîche' :  '/nl/recept',
'/nl/smultip/gestoofde-doperwtjes-worteltjes-met-crème-fraîche/doperwt' :  '/nl/recept',
'/nl/smultip/gestoofde-doperwtjes-worteltjes-met-crème-fraîche/wortel' :  '/nl/recept',
'/nl/smultip/gevulde-saucijsjes' :  '/nl/recept',
'/nl/smultip/gevulde-saucijsjes/doperwt' :  '/nl/recept',
'/nl/smultip/gevulde-saucijsjes/sperzieboon' :  '/nl/recept',
'/nl/smultip/gevulde-saucijsjes/wortel' :  '/nl/recept',
'/nl/smultip/gezoete-boterboontjes' :  '/nl/recept',
'/nl/smultip/gezoete-boterboontjes/boterboon' :  '/nl/recept',
'/nl/smultip/haricots-verts-op-mediterraanse-wijze' :  '/nl/recept',
'/nl/smultip/haricots-verts-op-zn-hollands' :  '/nl/recept',
'/nl/smultip/haricots-verts-op-zn-mexicaans' :  '/nl/recept',
'/nl/smultip/italiaanse-mais-frittata' :  '/nl/recept',
'/nl/smultip/italiaanse-mais-frittata/mais' :  '/nl/recept',
'/nl/smultip/kikkererwten-egyptian-style' :  '/nl/recept',
'/nl/smultip/kikkererwten-egyptian-style/kikkererwt' :  '/nl/recept',
'/nl/smultip/kipstoofpotje' :  '/nl/recept',
'/nl/smultip/kipstoofpotje/groene-kidneyboon' :  '/nl/recept',
'/nl/smultip/knoflooklinzen-portsaus' :  '/nl/recept',
'/nl/smultip/knoflooklinzen-portsaus/linzen' :  '/nl/recept',
'/nl/smultip/krabsalade-met-ma%C3%A9s' :  '/nl/recept',
'/nl/smultip/krabsalade-met-ma%C3%A9s/mais' :  '/nl/recept',
'/nl/smultip/kruidige-cousous' :  '/nl/recept',
'/nl/smultip/kruidige-cousous/groene-kidneyboon' :  '/nl/recept',
'/nl/smultip/linzen-met-paddenstoelen' :  '/nl/recept',
'/nl/smultip/linzen-met-paddenstoelen/linzen' :  '/nl/recept',
'/nl/smultip/linzen-op-zn-marokkaans' :  '/nl/recept',
'/nl/smultip/linzen-op-zn-marokkaans/linzen' :  '/nl/recept',
'/nl/smultip/ma%C3%A9s-pannenkoekjes' :  '/nl/recept',
'/nl/smultip/ma%C3%A9s-pannenkoekjes/mais' :  '/nl/recept',
'/nl/smultip/mac%C3%A9doine-met-champignons' :  '/nl/recept',
'/nl/smultip/mac%C3%A9doine-met-champignons/doperwt' :  '/nl/recept',
'/nl/smultip/mac%C3%A9doine-met-champignons/sperzieboon' :  '/nl/recept',
'/nl/smultip/mac%C3%A9doine-met-champignons/wortel' :  '/nl/recept',
'/nl/smultip/mais-salsa' :  '/nl/recept',
'/nl/smultip/mais-salsa/mais' :  '/nl/recept',
'/nl/smultip/mexicaanse-taco’s' :  '/nl/recept',
'/nl/smultip/mexicaanse-taco’s/rode-kidneyboon' :  '/nl/recept',
'/nl/smultip/ovenschotel-met-rode-kidneybonen-en-champignons' :  '/nl/recept',
'/nl/smultip/ovenschotel-met-rode-kidneybonen-en-champignons/rode-kidneyboon' :  '/nl/recept',
'/nl/smultip/pasta-cannellini' :  '/nl/recept',
'/nl/smultip/pasta-cannellini/cannelliniboon' :  '/nl/recept',
'/nl/smultip/pittige-doperwtjes-worteltjes' :  '/nl/recept',
'/nl/smultip/pittige-doperwtjes-worteltjes/doperwt' :  '/nl/recept',
'/nl/smultip/pittige-doperwtjes-worteltjes/wortel' :  '/nl/recept',
'/nl/smultip/provencaalse-bonen' :  '/nl/recept',
'/nl/smultip/provencaalse-bonen/cannelliniboon' :  '/nl/recept',
'/nl/smultip/reuzenbonen-op-zn-afrikaans' :  '/nl/recept',
'/nl/smultip/reuzenbonen-op-zn-afrikaans/reuzenboon' :  '/nl/recept',
'/nl/smultip/reuzenbonen-tomatensaus' :  '/nl/recept',
'/nl/smultip/reuzenbonen-tomatensaus/reuzenboon' :  '/nl/recept',
'/nl/smultip/risotto-met-borlotti-bonen' :  '/nl/recept',
'/nl/smultip/rode-kool-met-verse-appeltjes' :  '/nl/recept',
'/nl/smultip/rode-kool-met-verse-appeltjes/rode-kool' :  '/nl/recept',
'/nl/smultip/rode-kool-stoofpotje-met-rode-wijn' :  '/nl/recept',
'/nl/smultip/rode-kool-stoofpotje-met-rode-wijn/rode-kool' :  '/nl/recept',
'/nl/smultip/romige-champignonsoep-met-hoedje' :  '/nl/recept',
'/nl/smultip/romige-champignonsoep-met-hoedje/champignon' :  '/nl/recept',
'/nl/smultip/romige-spinazie' :  '/nl/recept',
'/nl/smultip/romige-spinazie/spinazie' :  '/nl/recept',
'/nl/smultip/salade-mac%C3%A9doine' :  '/nl/recept',
'/nl/smultip/salade-mac%C3%A9doine/doperwt' :  '/nl/recept',
'/nl/smultip/salade-mac%C3%A9doine/sperzieboon' :  '/nl/recept',
'/nl/smultip/salade-mac%C3%A9doine/wortel' :  '/nl/recept',
'/nl/smultip/sperzieboontjes-met-champignons' :  '/nl/recept',
'/nl/smultip/sperzieboontjes-met-champignons/sperzieboon' :  '/nl/recept',
'/nl/smultip/sperzieboontjes-op-franse-wijze' :  '/nl/recept',
'/nl/smultip/sperzieboontjes-op-franse-wijze/sperzieboon' :  '/nl/recept',
'/nl/smultip/spinazie-met-pijnboompitjes' :  '/nl/recept',
'/nl/smultip/spinazie-met-pijnboompitjes/spinazie' :  '/nl/recept',
'/nl/smultip/spinazie-met-zongedroogde-tomaatjes' :  '/nl/recept',
'/nl/smultip/spinazie-met-zongedroogde-tomaatjes/spinazie' :  '/nl/recept',
'/nl/smultip/stamppotje-met-reuzenbonen' :  '/nl/recept',
'/nl/smultip/stamppotje-met-reuzenbonen/reuzenboon' :  '/nl/recept',
'/nl/smultip/tapa-van-mais-en-chorizo' :  '/nl/recept',
'/nl/smultip/tapa-van-mais-en-chorizo/mais' :  '/nl/recept',
'/nl/smultip/toast-met-paddenstoelen' :  '/nl/recept',
'/nl/smultip/toast-met-paddenstoelen/champignon' :  '/nl/recept',
'/nl/smultip/toast-met-paddenstoelen/oesterzwam' :  '/nl/recept',
'/nl/smultip/tomaten-blauwe-kaassalade' :  '/nl/recept',
'/nl/smultip/tortilla-met-kip-en-salsa' :  '/nl/recept',
'/nl/smultip/tortilla-met-kip-en-salsa/rode-kidneyboon' :  '/nl/recept',
'/nl/smultip/tortillachips-met-chilibonen' :  '/nl/recept',
'/nl/smultip/tuinboontjes-frisse-yoghurtsaus' :  '/nl/recept',
'/nl/smultip/tuinboontjes-frisse-yoghurtsaus/tuinboon' :  '/nl/recept',
'/nl/smultip/tuinboontjes-lyonnaise' :  '/nl/recept',
'/nl/smultip/tuinboontjes-lyonnaise/tuinboon' :  '/nl/recept',
'/nl/smultip/tuinboontjes-met-pesto' :  '/nl/recept',
'/nl/smultip/tuinboontjes-met-pesto/tuinboon' :  '/nl/recept',
'/nl/smultip/winters-rode-kool-potje' :  '/nl/recept',
'/nl/smultip/winters-rode-kool-potje/rode-kool' :  '/nl/recept',
'/nl/smultip/witte-bonen-met-kerriemadras' :  '/nl/recept',
'/nl/smultip/witte-bonen-met-kerriemadras/witte-boon' :  '/nl/recept',
'/nl/smultip/witte-bonen-op-winterse-wijze' :  '/nl/recept',
'/nl/smultip/witte-bonen-op-winterse-wijze/witte-boon' :  '/nl/recept',
'/nl/smultip/witte-bonen-stoofpotje' :  '/nl/recept',
'/nl/smultip/witte-bonen-stoofpotje/witte-boon' :  '/nl/recept',
'/nl/smultip/worteltjes-met-amandel-en-kerrie' :  '/nl/recept',
'/nl/smultip/worteltjes-met-amandel-en-kerrie/wortel' :  '/nl/recept',
'/nl/smultip/worteltjes-met-dille' :  '/nl/recept',
'/nl/smultip/worteltjes-met-dille/wortel' :  '/nl/recept',
'/nl/user' :  '/nl',
'/nl/user/password' :  '/nl',
'/nl/user/register' :  '/nl',
'/over-bonduelle/jobs' :  '/nl',
'/privacy-statement' :  '/nl/privacybeleid',
'/producten' :  '/nl/producten',
'/recept/balletjes-in-tomatensaus-met-kikkererwtjes' :  '/nl/recept',
'/recept/caribbean-plaattaart-met-kidneybonen-mais-en-kaas' :  '/nl/recept',
'/recept/jet-kookt-met-daisy-edamamespread-op-toast' :  '/nl/recept',
'/recept/jet-kookt-met-daisy-salade-met-edamame-en-avocado' :  '/nl/recept',
'/recept/jet-kookt-met-kees-brownies-van-zwarte-bonen' :  '/nl/recept',
'/recept/jet-kookt-met-kees-geroosterde-kikkererwten' :  '/nl/recept',
'/recept/parmentierschotel-met-linzen-en-ricotta' :  '/nl/recept',
'/recept/poke-bowl-met-sushirijst-avocado-en-kikkererwten' :  '/nl/recept',
'/recept/poke-bowl-met-sushirijst-zalm-en-edamame' :  '/nl/recept',
'/recept/poke-bowl-met-tonijn-kidneybonen-en-mango' :  '/nl/recept',
'/recept/veggie-eggie' :  '/nl/recept',
'/recepten' :  '/nl/recept',
'/sites/www.bonduelle.be/files/styles/product_cat_icon/public/?itok=A-z-7KT_' :  '/nl'
};
